'use strict';

angular.module('shiftTraderApp')
    .directive('saDaysOffManagementDetailsPane', ['TimeService', 'toastr', function (TimeService, toastr) {
      return {
        templateUrl: 'views/daysOff/saDaysOffManagementDetailsPane.html',
        restrict: 'A',
        scope: {
          me: '='
        },
        controllerAs: 'detailsCtrl',
        bindToController: true,
        controller: ['$scope', 'DaysOffManagementModalService', 'DaysOffUserStatsService', 'DayOffLimitStore', 'DaysOffStore', 'Session', 'ViewDayOffModalService', 'WorkPeriods', 'SAErrorHandler', 'UserPermissionsService', 'UsersStore',
          function($scope, DaysOffManagementModalService, DaysOffUserStatsService, DayOffLimitStore, DaysOffStore, Session, ViewDayOffModalService, WorkPeriods, SAErrorHandler, UserPermissionsService, UsersStore) {
            var vm = this;

            vm.state = {
              daysOffViewState: 'approved',
              lastSelectedDayOffId: undefined,
              runLimitPositionAnalysis: true,
              rawPermissions: null,
              derivedPermissions: null
            };

            var permissionsToLookUp = [
              'days_off.add_message',
              'days_off.add_message_to_mine',
              'days_off.cancel_my_request',
              'days_off.remove',
              'days_off.approve',
              'days_off.disapprove'
            ];

            function processRawPermissions() {
              var rawPerms = vm.state.rawPermissions;
              var myReq = vm.selectedDayOff && vm.selectedDayOff.user && vm.selectedDayOff.user.id === vm.me.id;

              vm.state.derivedPermissions = {
                canSendMessage: rawPerms['days_off.add_message'] || myReq && rawPerms['days_off.add_message_to_mine'],
                canRemove: rawPerms['days_off.remove'],
                canCancel: rawPerms['days_off.cancel_my_request'],
                canApprove: rawPerms['days_off.approve'],
                canDisapprove: rawPerms['days_off.disapprove']
              };

              setMessagePlaceholder();
            }

            UserPermissionsService.getCanDict(permissionsToLookUp, 'current')
              .then(function(dikt) {
                vm.state.rawPermissions = dikt;

                processRawPermissions();
              });

            vm.commForm = {
              message: ''
            };

            vm.positionRelativeToLimitCache = {};

            vm.messagePlaceholderText = '';

            function calculateStatus() {
              if (vm.selectedDayOff.$isApproved()) {
                return 'APPROVED';
              } else if (vm.selectedDayOff.$isDisapproved()) {
                return 'DISAPPROVED';
              } else if (vm.selectedDayOff.$isPending()) {
                return 'PENDING';
              } else if (vm.selectedDayOff.$isExpired()) {
                return 'EXPIRED';
              } else if (vm.selectedDayOff.$isCancelled()) {
                return 'CANCELLED';
              } else if (vm.selectedDayOff.$wasRemoved()) {
                return 'REMOVED';
              }
            }

            function setMessagePlaceholder() {
              if (vm.selectedDayOff && vm.me.id === vm.selectedDayOff.user.id) {
                vm.messagePlaceholderText = 'Reply to your day off request.';
              } else if (vm.state.derivedPermissions && vm.state.derivedPermissions.canSendMessage && vm.selectedDayOff && vm.me.id !== vm.selectedDayOff.user.id) {
                vm.messagePlaceholderText = 'Ask a question or provide explanation for your decision.';
              }
            }

            function getPositionRelativeToLimitFromCache(weekIdx, dayIdx) {
              return vm.positionRelativeToLimitCache[weekIdx + '-' + dayIdx];
            }

            function calcRequestPositionRelativeToLimit(weekIdx, dayIdx) {
              var dtTwix = $scope.dataByWeek[weekIdx].days[dayIdx].range_twix;

              DaysOffStore.getDaysOffIntersectingDate(dtTwix.start)
                .then(function(daysOff) {
                  var filteredSortedDaysOff = _.sortBy(_.where(daysOff, function(dayOff) {
                    return dayOff.$isPending() || dayOff.$isApproved();
                  }), function(dayOff) {
                    return dayOff._created_at_unix;
                  });

                  DayOffLimitStore.getLimitForDate(dtTwix.start)
                    .then(function(limitRecord) {

                      var matchingIdx = _.findIndex(filteredSortedDaysOff, {id: vm.selectedDayOff.id});
                      var position;
                      var cls = '';

                      if (matchingIdx > -1) {
                        // just in case we don't have a limit for this day, go ahead and set position and a class
                        position = matchingIdx + 1;
                        $scope.dataByWeek[weekIdx].days[dayIdx].limitPosition = position;
                        cls = 'no-limit';


                        // only do this if we have a limit for this day.
                        if (!_.isNull(limitRecord)) {
                          $scope.dataByWeek[weekIdx].days[dayIdx].limitRecord = limitRecord;

                          if (position > limitRecord.limit) {
                            cls = 'over-limit';
                          } else if (position < limitRecord.limit) {
                            cls = 'under-limit';
                          } else if (position === limitRecord.limit) {
                            cls = 'at-limit';
                          }

                          vm.positionRelativeToLimitCache[weekIdx + '-' + dayIdx] = {
                            limitClass: cls,
                            limitPosition: position,
                            limitRecord: limitRecord
                          };
                        }

                        if (cls !== '') {
                          $scope.dataByWeek[weekIdx].days[dayIdx]._cssClasses[cls] = true;
                        }
                      }
                    }, function() {
                      console.log('limit issue');
                    });

                }, function() {
                  console.log('issue pulling daysOff');
                });

            }


            function setupWeekCalendar() {
              var currentDate = moment(DaysOffManagementModalService.getCurrentDate());
              var firstWeek = TimeService.getWeekTwixFromMoment(moment(vm.selectedDayOff.range_twix.start).startOf('week'));
              var startOfMonth = moment((TimeService.getWeekTwixFromMoment(moment(vm.selectedDayOff.range_twix.start).startOf('month'))).end).startOf('month');

              $scope.weeks = _.map([0,1,2,3,4], function(x) {
                return (moment(firstWeek.start).add(x, 'weeks')).twix(moment(firstWeek.start).add(x+1, 'weeks'));
              });

              $scope.datesByWeek = _.map($scope.weeks, function(week) {
                return _.map(_.range(7), function(dayNum) {
                  return moment(week.start).add(dayNum, 'days').twix(moment(week.start).add(dayNum + 1, 'days'));
                });
              });

              var isMultiDayRequest = vm.selectedDayOff.range_twix.start.dayOfYear() !== vm.selectedDayOff.range_twix.end.dayOfYear();
              var relativePositionLimitAnalysisToExec = [];

              var dayStartHour = Session.getWorkDayStartHour();

              $scope.dataByWeek = _.map($scope.datesByWeek, function (weekOfDays, weekIdx) {
                return {
                  week: $scope.weeks[weekIdx],
                  days: _.map(weekOfDays, function (dt, dayIdx) {
                    // return ._cssClasses;
                    // need to know what is previous or next month
                    // need to know if this day is affected by the request

                    var dtIntersection = dt.overlaps(vm.selectedDayOff.range_twix) ? Math.abs(vm.selectedDayOff.range_twix.intersection(dt).length('minutes')) : 0;
                    var temp = {
                      range_twix: dt,
                      _cssClasses: {
                        previous_month: dt.start.isBefore(startOfMonth),
                        next_month: dt.start.isAfter(moment(startOfMonth).endOf('month')),
                        current_date: dt.start.isSame(currentDate, 'day'),
                        request_overlaps_day: (!isMultiDayRequest && dtIntersection > 0) || (isMultiDayRequest && dtIntersection > ( dayStartHour * 60)), // if this is a single day request OR if the request overlaps the day by MORE than dayStartHour hrs, then show it.
                        complete_overlap: dt.overlaps(vm.selectedDayOff.range_twix) &&
                          (vm.selectedDayOff.range_twix.start.isBefore(dt.start) || vm.selectedDayOff.range_twix.start.isSame(dt.start)) &&
                        (vm.selectedDayOff.range_twix.end.isAfter(dt.end) || vm.selectedDayOff.range_twix.end.isSame(dt.end))
                      }
                    };

                     if ((vm.selectedDayOff.$isApproved() || vm.selectedDayOff.$isPending()) && (temp._cssClasses.request_overlaps_day || temp._cssClasses.complete_overlap)) {
                       var cacheTry = getPositionRelativeToLimitFromCache(weekIdx, dayIdx);

                       if (cacheTry) {
                         temp._cssClasses[cacheTry.limitClass] = true;
                         temp.limitRecord = cacheTry.limitRecord;
                         temp.limitPosition = cacheTry.limitPosition;
                       } else {
                         // pull up the limit on that day AND all DaysOff records on that day to calculate where this request is on each day
                         relativePositionLimitAnalysisToExec.push([weekIdx, dayIdx]);
                       }
                     }

                    return temp;
                  })
                };
              });

              _.each(relativePositionLimitAnalysisToExec, function(x) {
                calcRequestPositionRelativeToLimit(x[0], x[1]);
              });
            }

            function afterDaysOffStatsUpdate() {
              console.log('afterDaysOffStatsUpdate');

              vm.lastApprovedDayOff = _.last(_.sortBy(vm.daysOffStats.data.approved.items, function(dayOff) {
                return dayOff.start.unix();
              }));
            }


            function checkWorkPeriodOverlap() {
              WorkPeriods.getByUserId(vm.selectedDayOff.user.id, {
                start_time: moment(vm.selectedDayOff.range_twix.start).subtract(1, 'days').format('YYYY-MM-DD'),
                end_time: moment(vm.selectedDayOff.range_twix.end).add(1, 'days').format('YYYY-MM-DD')
              })
                .then(function(workPeriods) {
                  vm.overlappingWorkPeriods = _.where(workPeriods, function(wp) {
                    return wp.range_twix.overlaps(vm.selectedDayOff.range_twix) && Math.abs(wp.range_twix.intersection(vm.selectedDayOff.range_twix).length('minutes')) > 0;
                  });
                }, function() {

                });
            }



            function updatePane() {

              var newSelectedDayOff = DaysOffManagementModalService.getSelectedDayOff();
              var selectedDayOffChanged = false;

              // split this into isUndefined/notUndefined to handle the fact that getSelectDayOff() could return undefined
              if (_.isUndefined(newSelectedDayOff)) {
                if (vm.state.lastSelectedDayOffId !== newSelectedDayOff) {
                  vm.state.lastSelectedDayOffId = vm.selectedDayOff ? vm.selectedDayOff.id : undefined;
                  selectedDayOffChanged = true;
                }
              } else {
                if (vm.state.lastSelectedDayOffId !== newSelectedDayOff.id) {
                  vm.state.lastSelectedDayOffId = vm.selectedDayOff ? vm.selectedDayOff.id : undefined;
                  selectedDayOffChanged = true;
                }
              }

              if (selectedDayOffChanged) {
                vm.positionRelativeToLimitCache = {};
              }

              vm.selectedDayOff = newSelectedDayOff;

              if (vm.selectedDayOff) {
                if (vm.selectedDayOff.$usedOverrideToken()) {
                  UsersStore.getRecordById(parseInt(vm.selectedDayOff.metadata.override_token_granted_by_id))
                    .then(function(user) {
                      vm.overrideTokenGrantedBy = user;
                    }, function(response) {
                      console.log('Failed to fetch user who granted override token', response);
                    });
                }

                vm.state.statusInWords = calculateStatus();
                vm.selectedDayOff._mif = TimeService.minimalIntervalTimeFormat(vm.selectedDayOff.range_twix);
                setupWeekCalendar();

                if (vm.state.rawPermissions) {
                  // can only call this if permissions have loaded yet
                  processRawPermissions();
                }
                setMessagePlaceholder();

                // request their days off history
                vm.availabilityStartDate = moment.utc().startOf('day').subtract(6, 'months').startOf('month');
                vm.daysOffStats = DaysOffUserStatsService.initializeInstance();
                vm.daysOffStats.init(vm.selectedDayOff.user, vm.availabilityStartDate, afterDaysOffStatsUpdate, true);

                checkWorkPeriodOverlap();
              }
            }

            updatePane();

            _([DaysOffManagementModalService.selectedDayOffChangedEventName]).each(function(eventName) {
              $scope.$on(eventName, function() {
                updatePane();
              });
            });

            _([DaysOffManagementModalService.dateChangeEventName]).each(function(eventName) {
              $scope.$on(eventName, function() {
                if (vm.selectedDayOff) {

                  var currentDate = moment(DaysOffManagementModalService.getCurrentDate());

                  // if the new date doesn't include this day off, then deselect it
                  if (!vm.selectedDayOff.range_twix.contains(currentDate) && !vm.selectedDayOff.range_twix.start.isSame(currentDate, 'day')) {
                    DaysOffManagementModalService.setSelectedDayOffId(undefined);
                  } else {

                    // only reset the week calendar if we know that we're not about to setSelectedDayOffId to undefined!
                    setupWeekCalendar();
                  }
                }
              });
            });

            vm.changeDay = function(day) {
              DaysOffManagementModalService.setCurrentDate(TimeService.getBeginningOfDayFromDate(day.range_twix.start));
            };

            vm.sendMessage = function() {
              if (vm.state.derivedPermissions.canSendMessage) {
                vm.selectedDayOff.$sendMessage(vm.commForm.message, vm.me)
                  .then(function() {
                    vm.commForm.message = '';
                    toastr.success('Message sent for day off request!', 'Success');
                  }, function(response) {
                    console.log('sendMessage had an error');
                    console.log(response);
                    SAErrorHandler.processError(response);
                  });
              }
            };

            vm.approveDayOffRequest = function() {
              vm.selectedDayOff.$approve()
                .then(function() {
                  toastr.success(vm.selectedDayOff.$minimalIntervalTimeFormat() + ' Approved!', 'Success');
                  DaysOffStore.addOrReplaceRecord(vm.selectedDayOff);
                  DaysOffManagementModalService.setSelectedDayOffId(vm.selectedDayOff.id);
                  vm.state.statusInWords = calculateStatus();
                }, function(response) {
                  console.log('approveBlackoutDate had an error');
                  console.log(response);
                  SAErrorHandler.processError(response);
                });
            };

            vm.disapproveDayOffRequest = function() {
              vm.selectedDayOff.$disapprove()
                .then(function() {
                  toastr.success(vm.selectedDayOff.$minimalIntervalTimeFormat() + ' Disapproved!', 'Success');
                  DaysOffStore.addOrReplaceRecord(vm.selectedDayOff);
                  DaysOffManagementModalService.setSelectedDayOffId(vm.selectedDayOff.id);
                  vm.state.statusInWords = calculateStatus();
                }, function(response) {
                  console.log('disapproveBlackoutDate had an error');
                  console.log(response);
                  SAErrorHandler.processError(response);
                });
            };

            vm.removeDayOffRequest = function() {
              vm.selectedDayOff.$remove()
                .then(function() {
                  toastr.success(vm.selectedDayOff.$minimalIntervalTimeFormat() + ' Removed!', 'Success');
                  DaysOffStore.addOrReplaceRecord(vm.selectedDayOff);
                  DaysOffManagementModalService.setSelectedDayOffId(vm.selectedDayOff.id);
                  vm.state.statusInWords = calculateStatus();
                }, function(response) {
                  console.log('removeBlackoutDate had an error');
                  console.log(response);
                  SAErrorHandler.processError(response);
                })
            };


            vm.openViewDayOffModal = function(dayOff) {
              ViewDayOffModalService.openViewDayOffModal(dayOff.id,
                function(returnCode, data) {
                  if (returnCode >= 0) {
                    // something changed, so have daysOffStats re-init, and setSelectedDayOff again to force refresh
                    DaysOffManagementModalService.setSelectedDayOffId(vm.selectedDayOff.id);
                    vm.daysOffStats.init(vm.selectedDayOff.user, vm.availabilityStartDate, afterDaysOffStatsUpdate, true);
                  } else {
                    // nothing changed... just a placeholder
                  }
                })

            };

        }],
        link: function(scope, elem) {

        }
      };
    }]);
